import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/no-data-icon.svg'


const _hoisted_1 = { class: "social-pages__header mb-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "social-pages__table-header" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Asset Name")
], -1)
const _hoisted_3 = {
  key: 0,
  class: "v-table__no-data"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "No Data",
  height: "35"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, "No Data", -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]

import { useDataStore } from '@/stores/data';
import { computed, ref } from 'vue';
import { useDialogStore } from '@/stores/dialogs';
import VSocialSelect from './VSocialSelect.vue';
import VButton from './VButton.vue';
import AddIcon from './icons/other/AddIcon.vue';
import ConnectSocialDialog from '@/components/dialogs/ConnectSocialDialog.vue'
import ConnectedSocialPagesItem from './ConnectedSocialPagesItem.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ConnectedSocialPages',
  setup(__props) {

const dataStore = useDataStore()

const socialValue = ref<string | null>(null)

const data = computed(() => {

  const arr = dataStore.accounts.filter(item => item.active !== false)
  if (socialValue.value === 'fb') return arr.filter(item => item.type_id === 1) 
  if (socialValue.value === 'tiktok') return arr.filter(item => item.type_id === 3) 
  
  return arr
})

const dialog = useDialogStore()

const connectSocial = () => {
  dialog.open(ConnectSocialDialog)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(VButton, {
        big: "",
        onClick: connectSocial
      }, {
        default: _withCtx(() => [
          _createVNode(AddIcon),
          _createTextVNode(" Connect")
        ]),
        _: 1
      })
    ]),
    _hoisted_2,
    (_unref(data).length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data), (account, index) => {
      return (_openBlock(), _createBlock(ConnectedSocialPagesItem, {
        item: account,
        index: index,
        type: "accounts"
      }, null, 8, ["item", "index"]))
    }), 256))
  ], 64))
}
}

})